import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PrimengModule } from '../primeng/primeng.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { ProgressSpinnerModule } from 'primeng/progressspinner';

import { CommonRequestsRoutingModule } from './common-requests-routing.module';
import { UnitStatusComponent } from './unit-status/components/unit-status.component';
import { EditContractComponent } from './edit-contract/components/edit-contract.component';
import { ResendUcmComponent } from './resend-ucm/components/resend-ucm/resend-ucm.component';
import { CustomerSupportComponent } from './customer-support-activation/components/customer-support.component';
import { AuditTrailComponent } from './audit-trail/components/audit-trail/audit-trail.component';
import { CancelContractComponent } from './cancel-contract/components/cancel-contract/cancel-contract.component';
import { TransferContractComponent } from './transfer-contract/components/transfer-contract/transfer-contract.component';
import { ReportsComponent } from './reports/components/reports.component';
import { TestActivationComponent } from './reports/components/test-activation/test-activation.component';
import { CustomerActivationComponent } from './reports/components/customer-activation/customer-activation.component';
import { ContractReportComponent } from './reports/components/contract-report/contract-report.component';

@NgModule({
    declarations: [
        UnitStatusComponent,
        EditContractComponent,
        ResendUcmComponent,
        CustomerSupportComponent,
        AuditTrailComponent,
        CancelContractComponent,
        TransferContractComponent,
        ReportsComponent,
        TestActivationComponent,
        CustomerActivationComponent,
        ContractReportComponent
    ],
    imports: [
        CommonModule,
        PrimengModule,
        FormsModule,
        ReactiveFormsModule,
        CommonRequestsRoutingModule,
        HttpClientModule,
        ProgressSpinnerModule
    ],
    exports: [TestActivationComponent, CustomerActivationComponent, ContractReportComponent],
    entryComponents: []
})
export class CommonRequestsModule {}
